import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function fetchStateData() {
  try {
    const url = paths.getStateList();
    const response = await axiosInstance.get(url, {
      params: { skip: 0, limit: 500 },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

const useFetchStateData = () => {
  return useMutation(fetchStateData);
};

export { useFetchStateData };
